module.exports = __webpack_public_path__ + "img/1.9c63ec4b.png";